import { Component, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';

@Component({
  selector: 'app-delete-error',
  templateUrl: './delete-error.component.html',
  styleUrls: ['./delete-error.component.css'],
  imports: [BoDialogComponent, ButtonComponent],
})
export class DeleteErrorComponent {
  private dialogRef = inject(BrnDialogRef);

  readonly data = input.required<{ id: number }>();

  public onDismiss() {
    this.dialogRef.close();
  }
}
